import PagesStore from '../../Stores/Pages'

/**
 * @description Composant ne s'affichant lui ainsi que ses enfants uniquement
 * si la page correspondant au chemin passé en paramètre est affichable
 *
 * @param { Object } props
 * @param { String } props.path Chemin - ne doit pas changer, si le chemin change
 * changer la prop key sinon le composant peut ne pas rediriger vers le nouveau path
 * @param { React.ReactElement || Array<React.ReactElement> } children
 *
 * @returns { React.ReactElement|null } élément affiché si PATH accessible
**/
export default function IfPath ({ path='/', children })
{
	const is_allowed = PagesStore.useState(s => s.pages?.includes?.(path));

	if (is_allowed !== true) return null;

	return children;
}